import { render } from "./SaleByProduct.vue?vue&type=template&id=2050d735"
import script from "./SaleByProduct.vue?vue&type=script&lang=js"
export * from "./SaleByProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__